import { cn } from "@/lib/utils";
import { SearchNormal1 } from "iconsax-react";
import { FC } from "react";
import { Input } from "./ui/input";

type InputSearchProps = {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  id?: string;
};

const InputSearch: FC<InputSearchProps> = (props) => {
  return (
    <div className={cn("relative", props.className)}>
      <SearchNormal1
        size="16"
        color="#4F5D6D"
        className="absolute left-3 h-full"
      />
      <Input
        id={props.id}
        placeholder={props.placeholder}
        className="pl-9"
        value={props.value}
        onChange={(e) => props.onChange?.(e.target.value)}
      />
    </div>
  );
};

export default InputSearch;
